import { FC } from "react";
import { TagProps } from "./types";
import { Column } from "../containers";
import { Text } from "../typography";
import { useGeneralStore } from "../../stores";

const Tag: FC<TagProps> = ({ children }) => {
  const getTagById = useGeneralStore((s) => s.getTagById);

  const tag = getTagById(children?.$oid || "517") || {
    _id: { $oid: "517" },
    color: "red",
    name: "could not find tag",
  };

  return (
    <Column
      style={{ padding: "3px 15px", borderRadius: 15 }}
      background={tag.color}
    >
      <Text bold color={"white"}>
        {tag.name}
      </Text>
    </Column>
  );
};

export default Tag;
